export default __webpack_public_path__ + "static/media/Screenshot_4.42224615.png";